import React, {Component} from 'react';
import { Image } from '@sketchpixy/rubix';


class LoadingContainer extends Component {
    render() {
        return (
           <div className="loading-container" style={{position: 'fixed', top: -100}}>
               <Image src="/imgs/app/loading.gif"/>
           </div>
        );
    }
}

export default LoadingContainer